import { COLORS, RADIUS, fontFamilyFor } from "../../theme";

const headingFont = (isArabic) =>
  isArabic ? fontFamilyFor("ar") : "'Playfair Display', serif";

export const Style = {
  page: {
    background: COLORS.dark,
    color: "#fff",
  },
  hero: {
    padding: { xs: "3rem 1.5rem", md: "6rem 3rem" },
    textAlign: "center",
    background: `linear-gradient(135deg, ${COLORS.dark} 0%, #2a1f1f 100%)`,
  },
  heroTitle: (isArabic) => ({
    fontFamily: headingFont(isArabic),
    fontSize: { xs: "2.6rem", md: "5rem" },
    fontWeight: 700,
    mb: "1.5rem",
    background: `linear-gradient(135deg, #fff 0%, ${COLORS.peach} 100%)`,
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
  }),
  subtitle: {
    fontSize: { xs: "1.1rem", md: "1.5rem" },
    color: "rgba(255,255,255,0.7)",
    maxWidth: "800px",
    margin: "0 auto",
  },
  section: {
    padding: { xs: "3rem 1.5rem", md: "6rem 3rem" },
    maxWidth: "1200px",
    margin: "0 auto",
  },
  sectionHeading: (isArabic) => ({
    fontFamily: headingFont(isArabic),
    fontSize: { xs: "2.2rem", md: "3rem" },
    color: COLORS.peach,
    mb: "2rem",
  }),
  paragraph: (isArabic) => ({
    fontFamily: fontFamilyFor(isArabic ? "ar" : "en"),
    fontSize: "1.2rem",
    lineHeight: 1.8,
    color: "rgba(255,255,255,0.8)",
    mb: "1.5rem",
    textAlign: isArabic ? "right" : "left",
  }),
  values: {
    display: "grid",
    gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
    gap: "2rem",
    mt: "4rem",
  },
  valueCard: {
    padding: "2.5rem",
    background: COLORS.gray,
    borderRadius: RADIUS.card,
    border: "1px solid rgba(255,255,255,0.05)",
  },
  valueIcon: {
    width: "52px",
    height: "52px",
    borderRadius: "12px",
    background: `linear-gradient(135deg, ${COLORS.gold}, ${COLORS.peach})`,
    color: COLORS.forest,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    mb: "1.2rem",
    fontSize: "24px",
  },
  valueTitle: (isArabic) => ({
    fontFamily: fontFamilyFor(isArabic ? "ar" : "en"),
    fontSize: "1.8rem",
    fontWeight: 700,
    color: COLORS.peach,
    mb: "1rem",
  }),
  valueBody: (isArabic) => ({
    fontFamily: fontFamilyFor(isArabic ? "ar" : "en"),
    fontSize: "1rem",
    lineHeight: 1.7,
    color: "rgba(255,255,255,0.75)",
  }),
  team: {
    display: "grid",
    gridTemplateColumns: {
      xs: "1fr",
      sm: "repeat(2, 1fr)",
      md: "repeat(3, 1fr)",
    },
    gap: "2rem",
    mt: "3rem",
  },
  teamMember: {
    textAlign: "center",
    padding: "2rem",
    background: COLORS.gray,
    borderRadius: RADIUS.card,
  },
  teamAvatar: {
    width: "120px",
    height: "120px",
    borderRadius: "50%",
    margin: "0 auto 1rem",
    padding: "3px",
    background: `linear-gradient(135deg, ${COLORS.forest}, ${COLORS.peach})`,
  },
  teamAvatarImg: {
    width: "100%",
    height: "100%",
    borderRadius: "50%",
    objectFit: "cover",
    display: "block",
  },
  teamRole: (isArabic) => ({
    fontFamily: fontFamilyFor(isArabic ? "ar" : "en"),
    fontSize: "1.15rem",
    fontWeight: 700,
    mb: "0.4rem",
  }),
  teamSub: {
    fontSize: "0.95rem",
    color: COLORS.peach,
  },
  ctaSection: {
    textAlign: "center",
    padding: { xs: "3rem 1.5rem", md: "4rem 3rem" },
    maxWidth: "1200px",
    margin: "0 auto",
  },
  ctaBody: (isArabic) => ({
    fontFamily: fontFamilyFor(isArabic ? "ar" : "en"),
    fontSize: "1.2rem",
    color: "rgba(255,255,255,0.8)",
    mb: "2rem",
    maxWidth: "600px",
    mx: "auto",
  }),
  ctaButton: (isArabic) => ({
    display: "inline-block",
    padding: "0.9rem 2.2rem",
    background: COLORS.peach,
    color: COLORS.dark,
    borderRadius: RADIUS.pill,
    fontWeight: 700,
    fontFamily: fontFamilyFor(isArabic ? "ar" : "en"),
    fontSize: "1rem",
    cursor: "pointer",
    border: "none",
    "&:hover": { background: COLORS.gold },
  }),
};
